module.exports = __webpack_public_path__ + "media/images/banner/planning/zh-hant-0ef5319225a5ac085e03d9a3d61e4195.jpg";